import { List } from "@mui/material";
import { IgListItemLink } from "@src/components/Navigation/BaseSideNav/IgListItemLink";
import { SectionHeader } from "@src/components/Navigation/BaseSideNav/SectionHeader";
import { BillingRoutes } from "@src/components/Utils/routes";
import { hardLogout } from "@src/utils";

interface SideNavBarBodyProps {
  drawerOpen: boolean;
}

export const AdminSideNavBarBody = ({ drawerOpen }: SideNavBarBodyProps) => {
  const isProd = import.meta.env.PROD;
  const feMode = import.meta.env.MODE;
  const showRegression =
    !isProd && !feMode.includes("prod") && !feMode.includes("beta");

  return (
    <List sx={{ px: drawerOpen ? 2 : 4 }}>
      <SectionHeader title="Billing" drawerOpen={drawerOpen} />
      <IgListItemLink
        Route={BillingRoutes.overview}
        drawerOpen={drawerOpen}
        hasAccess={true}
        exact={true}
      />
      <IgListItemLink
        Route={BillingRoutes.agency}
        drawerOpen={drawerOpen}
        hasAccess={true}
        exact={true}
      />
      <IgListItemLink
        Route={BillingRoutes.billingWorkflowTrace}
        drawerOpen={drawerOpen}
        hasAccess={true}
        exact={true}
      />
      <SectionHeader title="Agentic Logic" drawerOpen={drawerOpen} />
      <IgListItemLink
        Route={BillingRoutes.agenticLogicStats}
        drawerOpen={drawerOpen}
        hasAccess={true}
        exact={true}
      />
      <SectionHeader title="Tools" drawerOpen={drawerOpen} />
      <IgListItemLink
        Route={BillingRoutes.demoStoreManagement}
        drawerOpen={drawerOpen}
        hasAccess={true}
        exact={true}
      />
      {showRegression ? (
        <IgListItemLink
          Route={BillingRoutes.regression}
          drawerOpen={drawerOpen}
          hasAccess={true}
          exact={true}
        />
      ) : null}
      <IgListItemLink
        Route={BillingRoutes.featureFlags}
        drawerOpen={drawerOpen}
        hasAccess={true}
        exact={true}
      />
      <IgListItemLink
        Route={BillingRoutes.hardLogout}
        drawerOpen={drawerOpen}
        hasAccess={true}
        handleClick={hardLogout}
        isLink={false}
      />

      <SectionHeader title="Integrations" drawerOpen={drawerOpen} />
      <IgListItemLink
        Route={BillingRoutes.slackIntegrations!}
        drawerOpen={drawerOpen}
        hasAccess={true}
        exact={true}
      />
    </List>
  );
};
